import { InjectionToken } from '@angular/core';
import { environment } from '@envs/environment';

export interface IBMSSOConfig {
  clientId: string;
  clientSecret: string;
  redirectUri: string;
  isvOidcBaseUrl: string;
  responseType: string;
  scope?: string;
}

export const IBM_SSO_CONFIG = new InjectionToken<IBMSSOConfig>(
  'IBM_SSO_CONFIG',
  {
    factory: () => ({
      responseType: 'code',
      clientId: environment.client_id,
      clientSecret: environment.client_secret,
      isvOidcBaseUrl: environment.isvOidcBaseUrl,
      redirectUri: environment.localDomain || window.location.origin,
    }),
  },
);
